import { Body } from "@songtradr/design-language";
import { staticText } from "../../../../statics/static-text";
import { Flex } from "../../../flex/Flex.Parts";
import {
  ConfirmedIcon,
  IconContainer,
  Props,
  RuleProps,
  UnconfirmedIcon,
  isFieldErrorWithTypes,
} from "./PasswordRules.Parts";

const PasswordRuleIcon = ({ valid }: { valid: boolean }) => {
  return valid ? (
    <ConfirmedIcon aria-hidden="true" />
  ) : (
    <UnconfirmedIcon aria-hidden="true" />
  );
};

const PasswordRule = ({ errorType, errorMsg, error }: RuleProps) => {
  const invalid =
    error &&
    error.types &&
    ((Array.isArray(error.types[errorType]) &&
      error.types[errorType].some((msg: string) => msg === errorMsg)) ||
      error.types[errorType] === errorMsg);
  return (
    <Flex $align="center" $gap="1rem">
      <IconContainer $checked={!invalid}>
        <PasswordRuleIcon valid={!invalid || !error} />
      </IconContainer>
      <Body variant="small">{errorMsg}</Body>
    </Flex>
  );
};

export const PasswordRules = ({ passwordError }: Props) => {
  if (isFieldErrorWithTypes(passwordError) || !passwordError) {
    return (
      <Flex $flow="column" $gap="1rem">
        <Body variant="small">
          {staticText.inputs.password.newPassword.validation.title}
        </Body>
        <Flex $gap="5rem">
          <Flex $flow="column" $gap="1rem">
            <PasswordRule
              errorType="too_small"
              errorMsg={
                staticText.inputs.password.newPassword.validation.rules.minimum
              }
              error={passwordError}
            />
            <PasswordRule
              errorType="invalid_string"
              errorMsg={
                staticText.inputs.password.newPassword.validation.rules
                  .uppercase
              }
              error={passwordError}
            />
            <PasswordRule
              errorType="invalid_string"
              errorMsg={
                staticText.inputs.password.newPassword.validation.rules
                  .lowercase
              }
              error={passwordError}
            />
          </Flex>
          <Flex $flow="column" $gap="1rem">
            <PasswordRule
              errorType="invalid_string"
              errorMsg={
                staticText.inputs.password.newPassword.validation.rules.digit
              }
              error={passwordError}
            />
            <PasswordRule
              errorType="invalid_string"
              errorMsg={
                staticText.inputs.password.newPassword.validation.rules
                  .specialCharacter
              }
              error={passwordError}
            />
          </Flex>
        </Flex>
      </Flex>
    );
  } else return null;
};
